import { Component } from '@angular/core';
import Swal from 'sweetalert2';
import { ReportResponseService } from '../../../services/report_response.service';

@Component({
  selector: 'app-report-review-w-comment',
  templateUrl: './report-review-w-comment.component.html',
  styleUrl: './report-review-w-comment.component.scss'
})
export class ReportReviewWCommentComponent {
  constructor(
    private reportResponseService: ReportResponseService, // 🔹 Agregar servicio para obtener los reportes
  ) {
  }
  reviewerComment: string = ''; // 🔹 Nuevo campo para el comentario del revisor
  selectedReportResponseId: string = ''; // 🔹 Nuevo campo para el reporte seleccionado
  existingReport: boolean = false; // 🔹 Indica si existe un reporte en el periodo seleccionado

  ngOnInit(): void {
    //verificar si se está cargando el reporte por id
    this.reportResponseService.selectedReportResponseId$.subscribe((id: string) => {
      if (id) {
        this.selectedReportResponseId = id; // Establecer el ID del reporte seleccionado
        this.existingReport = true; // Si hay reporte, lo marcamos como existente
      } else {
        console.warn('No se recibió ningún ID en la ruta');
      }
    }
    )
  };

  approveReportResponse() {
    Swal.fire({
      title: 'Comentario del Revisor',
      input: 'textarea',
      inputLabel: 'Agrega un comentario (opcional)',
      inputPlaceholder: 'Escribe tu comentario aquí...',
      inputAttributes: {
        'aria-label': 'Escribe tu comentario aquí'
      },
      showCancelButton: true,
      confirmButtonText: 'Aprobar'
    }).then((result) => {
      if (result.isConfirmed) {
        const comentario = result.value || '';
        this.reportResponseService.updateStateInAccept(this.selectedReportResponseId, comentario).subscribe({
          next: () => {
            this.reportResponseService.setSelectedReportResponseId(this.selectedReportResponseId)
            Swal.fire('Éxito', 'Reporte aprobado', 'success')
          },
          error: (err) => {
            console.error('Error aprobando reporte:', err);
            Swal.fire('Error', 'Ocurrió un error al aprobar el reporte', 'error');
          }
        });
      }
    });
  }

  rejectReportResponse() {
    Swal.fire({
      title: 'Comentario del Revisor',
      input: 'textarea',
      inputLabel: 'Agrega un comentario (opcional)',
      inputPlaceholder: 'Escribe tu comentario aquí...',
      inputAttributes: {
        'aria-label': 'Escribe tu comentario aquí'
      },
      showCancelButton: true,
      confirmButtonText: 'Rechazar'
    }).then((result) => {
      if (result.isConfirmed) {
        const comentario = result.value || '';
        this.reportResponseService.updateStateInReject(this.selectedReportResponseId, comentario).subscribe({
          next: () => {
            Swal.fire('Éxito', 'Reporte rechazado', 'success'),
            this.reportResponseService.setSelectedReportResponseId(this.selectedReportResponseId)
          },
          error: (err) => {
            console.error('Error rechazando reporte:', err);
            Swal.fire('Error', 'Ocurrió un error al rechazar el reporte', 'error');
          }
        });
      }
    });
  }

  correctionReportResponse() {
    Swal.fire({
      title: 'Comentario del Revisor',
      input: 'textarea',
      inputLabel: 'Agrega un comentario (opcional)',
      inputPlaceholder: 'Escribe tu comentario aquí...',
      inputAttributes: {
        'aria-label': 'Escribe tu comentario aquí'
      },
      showCancelButton: true,
      confirmButtonText: 'Enviar para corrección'
    }).then((result) => {
      if (result.isConfirmed) {
        const comentario = result.value || '';
        this.reportResponseService.updateStateCorrection(this.selectedReportResponseId,comentario).subscribe({
          next: () => {
            Swal.fire('Éxito', 'Reporte enviado para corrección', 'success'),
            this.reportResponseService.setSelectedReportResponseId(this.selectedReportResponseId)
          },
          error: (err) => {
            console.error('Error enviando reporte para corrección:', err);
            Swal.fire('Error', 'Ocurrió un error al enviar el reporte para corrección', 'error');
          }
        });
      }
    });
  }

}
